import { ChakraText as Text, ChakraCheckbox as Checkbox, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import type { TermsProps } from "./Terms.d";

const termsCheckboxStyles = {
  a: {
    textDecoration: "underline",
  },
};

const Terms = ({ register, isDisabled = false, htmlContent, ...props }: TermsProps) => (
  <Flex alignItems="flex-start" {...props} order={{ base: 1, md: 0 }} mt={{ base: 6, md: 0 }}>
    <Checkbox
      name="agreeWithTerms"
      aria-labelledby="terms"
      ref={register}
      value="Y"
      isRequired
      size="lg"
      mr={2}
      isDisabled={isDisabled}
    />
    <Text
      id="terms"
      color="inherit"
      fontSize="sm"
      textAlign="start"
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
      sx={termsCheckboxStyles}
    />
  </Flex>
);

export default Terms;
